<ng-template [ngIf]="noTime"
             [ngIfThen]="teacherBusyRef"
             [ngIfElse]="timepickerRef"
>
</ng-template>

<ng-template #timepickerRef>
  <div class="new-date-time-picker"
       [class.mobile]="deviceService.isMobile()">
    <div class="navigate-block">
      <div class="navigate-wrap">
        <div class="nav" [class.hidden]="!canGoPreviousWeek" (click)="goPreviousWeek()">
          <app-icon width="4" height="8" file="chevron" icon="left"></app-icon>
        </div>

        <span *ngIf="!deviceService.isMobile()" class="select-month">{{ currentMonthName }}</span>

        <div class="nav right" [class.hidden]="!canGoNextWeek" (click)="goNextWeek()">
          <app-icon width="4" height="8" file="chevron" icon="left"></app-icon>
        </div>

        <span *ngIf="deviceService.isMobile()" class="select-month">{{ currentMonthName }}</span>
      </div>

      <span class="explanation-text"><app-timezone></app-timezone></span>
    </div>

    <div class="calendar">
      <div *ngFor="let day of daysList; let i = index; trackBy: trackByFn" class="day-wrap">
        <div class="day"
             [attr.title]="day?.label"
             [class.active]="day.is_active"
             [class.free]="day.is_free"
             [class.busy]="day.is_busy"
             [class.today]="day.is_today"
             [class.select]="isSelectedDate(day)">

          <span class="weekday">{{ weekdays[i].short }}</span>
          <span class="label-day">{{ day.label }}</span>
        </div>

        <div *ngFor="let time of convertEventToDate(day.events); let i = index; trackBy: trackByFn"
             class="time-interval"
             [attr.title]="time?.note"
             [class.active]="time.is_active"
             [class.free]="time.is_free"
             [class.busy]="time.is_busy"
             [class.select]="isSelectedTime(time)"
             (click)="selectTime(time)">
          <span class="label-time">{{ time.label }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #teacherBusyRef>
  <div class="teacher-busy">
    <span [innerHTML]="'datetime-picker.teacher-busy' | translate"></span>
    <a class="teacher-chat" (click)="openChat()">{{'datetime-picker.teacher-chat' | translate}}</a>
  </div>
</ng-template>
